module.exports = __webpack_public_path__ + "img/index01.b8684ea1.svg";